import { cn } from '@/utils/cn';

import { Tech } from './types';

type Props = Tech & {
    isSelected: boolean;
};

export const TechTag = ({ icon, isSelected, name }: Props) => (
    <div
        className={cn(
            `
              flex items-center gap-3 rounded-full border px-3 py-2
              transition-all duration-300

              sm:p-4
            `,
            isSelected ? 'opacity-100' : 'sm:opacity-30',
        )}
    >
        <div
            className={`
              h-4

              [&>svg]:size-full

              sm:h-7
            `}
        >
            {icon}
        </div>
        <span
            className={`
              text-base font-bold

              sm:text-xl
            `}
        >
            {name}
        </span>
    </div>
);
